module.exports = __webpack_public_path__ + "static/media/redcross.11b21652.svg";